import objectToFormData from 'object-to-formdata';


export default function laggTillKopieraFlyttaEllerKlonaWidget(appensThis, panelytansThis, widgetId, toPageId,
	// Named (but not all optional) parameters, as options object:
	{
		typLaggTillKopieraFlyttaEllerKlona,	// 'lägg till', 'kopiera', 'flytta' eller 'klona'
		order = 1,		// Optional. Andra värden förekommer endast vid kloning!
	}
)
{
	// Kolla den felkänsliga inparametern typLaggTillKopieraFlyttaEllerKlona:
	// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
	const item = new Array('lägg till', 'kopiera', 'flytta', 'klona')
		.filter((item) => { return item === typLaggTillKopieraFlyttaEllerKlona; })[0] || null;
	console.assert(item,
		'Parametern \'typLaggTillKopieraFlyttaEllerKlona\' är obligatorisk och måste vara ett av värdena \'lägg till\', \'kopiera\', \'flytta\' eller \'klona\'.'
	);

	let controller = null;

	switch (typLaggTillKopieraFlyttaEllerKlona)
	{
		case 'lägg till':
		case 'klona':
		case 'kopiera':
			controller = '/widget/copy-widget';
			break;

		case 'flytta':
			controller = '/widget/move-widget';
			break;
	}

	//console.log(`${typLaggTillKopieraFlyttaEllerKlona} widget till sida: ${widgetId} –> sidan ${toPageId} (order = ${order})`);

	appensThis.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

	// POSTa:
	appensThis.AjaxpostaOchHanteraResultat(controller, {
		formData: objectToFormData({ widgetId: widgetId, toPageId: toPageId, order: order }),
		//doljSpinnerOnSuccess: false,
		onSuccessFunction: (resultat) => {

			if (typLaggTillKopieraFlyttaEllerKlona === 'lägg till')
			{
				// Visa bara lyckatmeddelande:
				appensThis.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
				appensThis.$notify({
					group: 'tc',
					text: 'Kortet har lagts till på översikts­sidan.',
					type: 'success',
				});
			}

			if (typLaggTillKopieraFlyttaEllerKlona === 'klona')
			{
				// Ladda om sidan:

				// Här fortsätter sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs köra:
				//appensThis.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

				window.location.reload(true);
			}

			if (typLaggTillKopieraFlyttaEllerKlona === 'kopiera')
			{
				// Visa bara lyckatmeddelande:
				appensThis.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
				appensThis.$notify({
					group: 'tc',
					text: 'Kortet har kopierats.',
					type: 'success',
				});
			}

			if (typLaggTillKopieraFlyttaEllerKlona === 'flytta')
			{
				// Obs! Här laddar vi *inte* om sidan utan istället...
				// Ta bara bort widgeten från *skärmen*:
				appensThis.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
				panelytansThis.taBortWidgetFranSkarmen(widgetId);

				// Visa lyckatmeddelande:
				appensThis.$notify({
					group: 'tc',
					text: 'Kortet har flyttats.',
					type: 'success',
				});
			}
		},
	});
}

